import moment from 'moment';

export default class bucketList {

    getDateData = (bucketList) => {
        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        lastDay = moment(lastDay).format('YYYYMMDD');

        var year = date.getFullYear()-1;
        var month = 1;

        var currentDate = new Date(year, month, 0);
        currentDate = moment(currentDate).format('YYYYMMDD');

        var i = 0;
        while(currentDate <= lastDay) {

            i = i + 1;
            month = month + 1;
            if(month == 13) {
                year = year + 1;
                month = 1;
            }

            bucketList.push(
                {
                    value: i,
                    label: currentDate
                }
            )

            var currentDate = new Date(year, month, 0);
            currentDate = moment(currentDate).format('YYYYMMDD');

        }

    }

}